import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ReportDisaster() {
  const [agencyid, setagencyid] = useState('');
  const [city, setcity] = useState('')
  const [number, setnumber] = useState('')
  const [suggestions, setSuggestions] = useState([]);

  const nav = useNavigate()

  useEffect(() => {
    const s = localStorage.getItem('Agencyid');
    if (s) {
      setagencyid(s);
    }
  }, []);

  const [disasterData, setDisasterData] = useState({
    type: '',
    severity: '',
    city: '',
    description: '',
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setDisasterData({ ...disasterData, [name]: value });
  };




  
  useEffect(() => {
    fetchSuggestions();
  }, [disasterData.city]);


  const fetchSuggestions = () => {
    const mapboxAccessToken = 'pk.eyJ1IjoicHJhdGhhbTcwNCIsImEiOiJjbG1xaDJrdzEwNHVpMnFwaXloODIwc2Q0In0.M-0gUqeNHe6A9Z7LeaVFVw'; // Replace with your Mapbox access token

    fetch(
      `https://api.mapbox.com/geocoding/v5/mapbox.places/${disasterData.city}.json?country=IN&types=place&access_token=${mapboxAccessToken}`
    )
      .then((response) => response.json())
      .then((data) => {
        // Filter the results to get only city names
        const cityNames = data.features
          .filter((feature) => feature.place_type.includes('place'))
          .map((feature) => feature.place_name.split(',')[0]);

        // Update the suggestions state
        setSuggestions(cityNames);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };








  async function handleSubmit(event) {
    event.preventDefault();
    console.log('Disaster Data:', disasterData);

    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/reportdisaster', {
      method: 'POST',
      body: JSON.stringify({ disasterData, agencyid }),
      headers: { 'Content-Type': 'application/json' },
    });
    const post = await res.json();


    if(post ==="created")
{





    nav('/agencyachivements')
}



else{




  nav('/agencyachivements')






}



  }

  const formStyle = {
    maxWidth: '400px',
    margin: '0 auto',
    padding: '20px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '15px',
    border: '1px solid #ccc',
    borderRadius: '3px',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '3px',
    cursor: 'pointer',
  };

  return (<>

  <br />
    <form style={formStyle} onSubmit={handleSubmit}>
      <div>
        <label htmlFor="type">Type of Disaster:</label>
        <input
          style={inputStyle}
          type="text"
          id="type"
          name="type"
          value={disasterData.type}
          onChange={handleInputChange}
          required
        />
      </div>


      <div>
        <label htmlFor="severity">Severity:</label>
        <input
          style={inputStyle}
          type="text"
          id="severity"
          name="severity"
          value={disasterData.severity}
          onChange={handleInputChange}
          required
        />
      </div>
      <div>
        <label htmlFor="city">City:</label>
        <input
          style={inputStyle}
          type="text"
          id="city"
          name="city"
          value={disasterData.city}
          onChange={handleInputChange}
          required
        />


        
<ul className="mt-2">
          {suggestions.map((city, index) => (
            <li  key={index} className="p-2 border-b last:border-b-0"   onClick={() => setDisasterData({ ...disasterData, city })}
            >
              {city}
            </li>
          ))}
        </ul>

       


      </div>
      <div>
        <label htmlFor="description">Description:</label>
        <textarea
          style={inputStyle}
          id="description"
          name="description"
          value={disasterData.description}
          onChange={handleInputChange}
          required
        />
      </div>
      <button style={buttonStyle} type="submit">
        Submit
      </button>
    </form>
    </>
  );
}
